import { useEffect, useState } from 'react'
import { personalInfoTranslate } from '../../../../../i18n/translatedMessages'
import './menuForm.sass'

export const MenuForm = () => {

    const [url, setUrl] = useState('')

    useEffect(() => {
        setUrl(window.location.hash)
    }, [window.location.hash])

    return (
        <ul className="menu-form">
            <li className={url === '#personal' || url === '' ? 'active' : ''}>
                <a href="#personal">
                {personalInfoTranslate.personalInformation}
                </a>
            </li>
            <li className={url === '#socialNetwork' ? 'active' : ''}>
                <a href="#socialNetwork">
                    Redes Sociales y Foto
                </a>
            </li>
            <li className={url === '#family' ? 'active' : ''}>
                <a href="#family">
                    Informaciones Familiar
                </a>
            </li>
            <li className={url === '#address' ? 'active' : ''}>
                <a href="#address">
                    Informaciones de Domicílo
                </a>
            </li>
            <li className={url === '#health' ? 'active' : ''}>
                <a href="#health">
                    Informaciones de Salud
                </a>
            </li>
        </ul>
    )
}